import React, { useState } from "react";
import { ProcessWrapper, ProgressBar, ProgressBarIndicator } from "../styled";
import Contact from "../../components/contact/contact";
import Question from "../../components/question";
import { ReactComponent as HeartHand } from "../../assets/img/svg/confiansa_corazon.svg";
import { ReactComponent as HeartCoin } from "../../assets/img/svg/confiansa_mano_moneda.svg";

export default function Business({
  finishProcess,
  setRecommendation,
  startOver,
  contact,
  setContact,
  setAssuranceUrl,
}) {
  const [step, setStep] = useState(0);

  const nextStep = () => {
    setStep(step + 1);
  };

  const goToStep = (newStep) => {
    setStep(newStep);
  };

  return (
    <ProcessWrapper>
      <ProgressBar>
        <ProgressBarIndicator progressWidth={(100 * (step + 1)) / 4} />
      </ProgressBar>

      {step === 0 && (
        <Contact
          nextStep={nextStep}
          setContact={setContact}
          contact={contact}
        />
      )}
      {step === 1 && (
        <Question
          goToStep={() => goToStep(0)}
          text="¿Qué deseas asegurar?"
          icon={<HeartHand fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Bienes Inmuebles",
              action: () => {
                setRecommendation({
                  title: "Seguro de Incendio y Lineas Aliadas",
                  phrase1:
                    "¡Te recomendamos Seguro de Incendio y Lineas Aliadas!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/contacto/");
                finishProcess();
              },
            },
            {
              label: "Los Vehículos",
              action: () => {
                setRecommendation({
                  title: "Seguro para tu flotilla",
                  phrase1:
                    "¡Te recomendamos cotizar un seguro para tu flotilla!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/contacto/");
                finishProcess();
              },
            },
            {
              label: "A mis empleados",
              action: () => setStep(3),
            },
          ]}
        />
      )}
      {/* {step === 2 && (
        <Question
          goToStep={() => goToStep(1)}
          text="¿Qué beneficio deseas brindarles?"
          icon={<HeartCoin fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Apoyarlos en gastos relacionados a la Salud",
              action: () => setStep(3),
            },
            {
              label: "Cobertura en caso de accidentes",
              action: () => {
                setRecommendation({
                  title: "Accidentes Personales",
                  phrase1:
                    "¡Te recomendamos un seguro de Accidentes Personales!",
                  phrase2: "",
                });
                setAssuranceUrl(
                  "https://confiansa.bi.com.gt/seguro-de-accidentes-personales/"
                );
                finishProcess();
              },
            },
            {
              label:
                "Apoyar a sus familiares con gastos en caso de fallecimiento",
              action: () => {
                setRecommendation({
                  title: "Seguro Colectivo de Vida",
                  phrase1: "  ¡Te recomendamos Seguro Colectivo de Vida  !",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/contacto/");
                finishProcess();
              },
            },
          ]}
        />
      )} */}
      {step === 3 && (
        <Question
          goToStep={() => goToStep(2)}
          text="¿Cuántos empleados tienes?"
          icon={<HeartHand fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Igual o menor a 4",
              action: () => {
                setRecommendation({
                  title: "Salud 360",
                  phrase1: "¡Te recomendamos Salud 360!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/salud-360/");
                finishProcess();
              },
            },
            {
              label: "De 5 a 25",
              action: () => {
                setRecommendation({
                  title: "Seguro de Minigrupos",
                  phrase1: "¡Te recomendamos Seguro de  Minigrupos!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/contacto/");
                finishProcess();
              },
            },
            {
              label: "De 26 en adelante",
              action: () => {
                setRecommendation({
                  title: "Gastos Médicos Colectivo",
                  phrase1:
                    "  ¡Te recomendamos un seguro de Gastos Médicos Colectivo!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/contacto/");
                finishProcess();
              },
            },
          ]}
        />
      )}
    </ProcessWrapper>
  );
}
